import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';

import { Snackbar } from '@mui/material';
const STRINGS = appStrings.modules.survey.output.blueprintSection;

type LockInSuccessAlertProps = Readonly<{
  open: boolean;
  onClose: () => void;
}>;

export function LockInSuccessAlert({ open, onClose }: LockInSuccessAlertProps) {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      message={STRINGS.lockInSuccess}
    />
  );
}
